/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';
import type { DigiticketsEventSessionsReport } from './DigiticketsEventSessionsReport';
import {
    DigiticketsEventSessionsReportFromJSON,
    DigiticketsEventSessionsReportFromJSONTyped,
    DigiticketsEventSessionsReportToJSON,
    DigiticketsEventSessionsReportToJSONTyped,
} from './DigiticketsEventSessionsReport';

/**
 * 
 * @export
 * @interface DigiticketsSessionsOverview
 */
export interface DigiticketsSessionsOverview {
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof DigiticketsSessionsOverview
     */
    date: ShiftiePlainDate;
    /**
     * 
     * @type {number}
     * @memberof DigiticketsSessionsOverview
     */
    totalSpacesSold: number;
    /**
     * 
     * @type {Array<DigiticketsEventSessionsReport>}
     * @memberof DigiticketsSessionsOverview
     */
    eventSessionReports: Array<DigiticketsEventSessionsReport>;
}

/**
 * Check if a given object implements the DigiticketsSessionsOverview interface.
 */
export function instanceOfDigiticketsSessionsOverview(value: object): value is DigiticketsSessionsOverview {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('totalSpacesSold' in value) || value['totalSpacesSold'] === undefined) return false;
    if (!('eventSessionReports' in value) || value['eventSessionReports'] === undefined) return false;
    return true;
}

export function DigiticketsSessionsOverviewFromJSON(json: any): DigiticketsSessionsOverview {
    return DigiticketsSessionsOverviewFromJSONTyped(json, false);
}

export function DigiticketsSessionsOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigiticketsSessionsOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'date': ShiftiePlainDateFromJSON(json['date']),
        'totalSpacesSold': json['totalSpacesSold'],
        'eventSessionReports': ((json['eventSessionReports'] as Array<any>).map(DigiticketsEventSessionsReportFromJSON)),
    };
}

  export function DigiticketsSessionsOverviewToJSON(json: any): DigiticketsSessionsOverview {
      return DigiticketsSessionsOverviewToJSONTyped(json, false);
  }

  export function DigiticketsSessionsOverviewToJSONTyped(value?: DigiticketsSessionsOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': ShiftiePlainDateToJSON(value['date']),
        'totalSpacesSold': value['totalSpacesSold'],
        'eventSessionReports': ((value['eventSessionReports'] as Array<any>).map(DigiticketsEventSessionsReportToJSON)),
    };
}

